import { Button } from "@components/common/button"
import { DictType } from "@pma/types"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@components/common/alert-dialog"
import axios from "axios"
import { parseCookies } from "nookies"
import { useMutation } from "@tanstack/react-query"
import { toast } from "@hooks/use-toast"
import { ACCESS_TOKEN, queryClient } from "@pma/utils/constants"
import { DELETE_FILE_ENDPOINT, SERVER_URL } from "@pma/utils/api-routes"
import { LucideTrash, X } from "lucide-react"
import useTranslator from "@hooks/use-translator"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/common/tooltip"
import { useNavigate, useSearchParams } from "react-router-dom"
import { GroupedTasksContext } from "./context/GroupedTasksProvider"
import { useContext, useEffect, useState } from "react"
import { IGroupDeleteInput } from "./api-fns"

interface Props {
  group: { name: string; id: number }
  onClose?: Function
}

interface IGroupId {
  group_id: string
}
const DeleteGroup = ({ group }: Props) => {
  const { translate,locale } = useTranslator()

  const { deleteGroupMutation } = useContext(GroupedTasksContext)

  const [isOpen, setIsOpen] = useState(false)

  const handleDelete = (groupId: any) => {
    if (!groupId) return

    deleteGroupMutation?.mutate(groupId)
  }

  useEffect(() => {
    if (!deleteGroupMutation?.isPending && deleteGroupMutation?.isSuccess) {
      onClose()
    }
  }, [deleteGroupMutation?.isPending])

  const onClose = () => {
    setIsOpen(false)
  }

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <Tooltip>
        <TooltipTrigger>
          <AlertDialogTrigger>
            <Button variant={"ghost"} className='h-6 w-7 text-xs' size={"icon"}>
              <LucideTrash className='text-red-500' size={16} />
            </Button>
          </AlertDialogTrigger>
        </TooltipTrigger>
        <TooltipContent className='bg-destructive'>{translate("Delete group")}</TooltipContent>
      </Tooltip>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {translate("Proceed to delete")} {group?.name}?
          </AlertDialogTitle>
          <AlertDialogDescription>
            {translate("This group will be moved to trash")}.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            onClick={() => {
              onClose()
            }}
          >
            {translate("Cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            className='bg-destructive'
            disabled={deleteGroupMutation?.isPending}
            onClick={() => handleDelete(group.id)}
          >
            {translate("Continue")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default DeleteGroup
